import React, { FC, SVGProps } from "react";

const SearchIcon: FC<SVGProps<SVGElement>> = ({
  width = "24",
  height = "24",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.9659 14.2559H15.7559L20.7459 19.2559L19.2559 20.7459L14.2559 15.7559V14.9659L13.9859 14.6859C12.8459 15.6659 11.3659 16.2559 9.75586 16.2559C6.16586 16.2559 3.25586 13.3459 3.25586 9.75586C3.25586 6.16586 6.16586 3.25586 9.75586 3.25586C13.3459 3.25586 16.2559 6.16586 16.2559 9.75586C16.2559 11.3659 15.6659 12.8459 14.6859 13.9859L14.9659 14.2559ZM5.25586 9.75586C5.25586 12.2459 7.26586 14.2559 9.75586 14.2559C12.2459 14.2559 14.2559 12.2459 14.2559 9.75586C14.2559 7.26586 12.2459 5.25586 9.75586 5.25586C7.26586 5.25586 5.25586 7.26586 5.25586 9.75586Z"
      fill="#1E1C1C"
    />
  </svg>
);

export default SearchIcon;
